import { render, staticRenderFns } from "./SuperFooter.vue?vue&type=template&id=4d4f3bbc&scoped=true"
import script from "./SuperFooter.vue?vue&type=script&lang=js"
export * from "./SuperFooter.vue?vue&type=script&lang=js"
import style0 from "./SuperFooter.vue?vue&type=style&index=0&id=4d4f3bbc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.24_babel-core@6.26.3_cache-loader@4.1.0_webpack@5.10_ei55e3dlglycqw3km3vwexq5ke/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4f3bbc",
  null
  
)

export default component.exports